export const ADD_PLACE = 'ADD_PLACE';

export const addPlace = (place) => {
  return { type: ADD_PLACE, place };
}
